import type { ConversationPlan } from '@knownow/domain'

/**
 * Plan deletion is intentionally NOT part of `IConversationPlanRepository` —
 * it is a UI-only capability. The designer agent must never delete plans, and
 * the agent's MCP tool surface only exposes the shared `IConversationPlanRepository`
 * interface, which has no `deletePlan` method. To delete, callers must hold a
 * concrete repository that implements `IPlanDeleter` (i.e. the web app's
 * `SupabaseConversationPlanRepository`).
 */
export interface IPlanDeleter {
  getById(id: string): Promise<ConversationPlan>
  deletePlan(planId: string, deletedAt: Date): Promise<void>
}

export interface DeletePlanInput {
  readonly planId: string
}

export class DeletePlanUseCase {
  constructor(private readonly repo: IPlanDeleter) {}

  async execute(input: DeletePlanInput): Promise<void> {
    // Throws NotFoundError if the plan doesn't exist or is already soft-deleted —
    // RLS-scoped getById is the authoritative access check.
    await this.repo.getById(input.planId)
    await this.repo.deletePlan(input.planId, new Date())
  }
}
